import type { CalendarBot } from '../services/calendarWebSocketService';

/** Bot statuses that mean the call is over when the page is connected to that bot. */
export const ENDED_BOT_STATUSES: ReadonlyArray<CalendarBot['status']> = ['terminated', 'failed'];

/**
 * The selected bot when calendar_sync has said it ended, else null. A bot that
 * is not in the list yet ends nothing: a manual bot is added by calendar_sync's
 * status poll (up to 10 s after creation), and the rep's meeting may admit it
 * sooner. The end also arrives on the recall socket (`session_ended`).
 */
export function endedSelectedBot(
  calendarBots: ReadonlyArray<CalendarBot>,
  selectedBotId: string | null | undefined,
): CalendarBot | null {
  if (!selectedBotId) return null;
  const selectedBot = calendarBots.find((bot) => bot?.botId === selectedBotId);
  return selectedBot && ENDED_BOT_STATUSES.includes(selectedBot.status) ? selectedBot : null;
}
